// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"BreadcrumbComponent_breadcrumb__GAX0s","breadcrumbLink":"BreadcrumbComponent_breadcrumbLink__t5FMp"};